'use strict';

import React, { useEffect, useState } from 'react';
import Alert from '../Alert';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import { withPageBase } from '../PageBase';

import NoonaServiceCard from './noona/NoonaServiceCard';
import TaysPolkuServiceCard from './tayspolku/TaysPolkuCard';
import LibreviewServiceCard from './libreview/LibreviewServiceCard';
import CoxaPolkuServiceCard from './coxa/CoxaPolkuCard';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { LUKITTU } from '../../definitions/NoonaConstants';
import { COXA_POLKU } from '../../definitions/PolkuConstants';
import { automaticallyDismissNoonaActivationNotification } from '../../data/service/noona/actions';
import { automaticallyDismissTaysPolkuActivationNotification } from '../../data/service/tayspolku/actions';
import { automaticallyDismissLibreviewActivationNotification } from '../../data/service/libreview/actions';
import { automaticallyDismissCoxaPolkuActivationNotification } from '../../data/service/coxapolku/actions';
import { BACKENDNOTIFICATIONS, SERVICES } from '../../data/reducer';
import { selectShowServicePagePlaceholder } from '../../data/service/selector';
import { doRequestDismissNotifications } from '../../data/notification/actions';

const { id: module_id } = module;

/**
 * On services pages are shown patient's service integrations.
 * Currently the only used service is Noona.
 *
 * A service will be listed if patient is eligible for it or is currently using it.
 * A service will not be listed if patient is not eligible for it.
 * */
const Services = (props) => {
  const {
    automaticallyDismissNoonaActivationNotification,
    automaticallyDismissTaysPolkuActivationNotification,
    automaticallyDismissLibreviewActivationNotification,
    automaticallyDismissCoxaPolkuActivationNotification,
    notificationData,
    data,
    isFetching,
    error,
  } = props;

  useEffect(() => {
    automaticallyDismissNoonaActivationNotification();
    automaticallyDismissTaysPolkuActivationNotification();
    automaticallyDismissLibreviewActivationNotification();
    automaticallyDismissCoxaPolkuActivationNotification();
  }, [notificationData]);

  if (isFetching) {
    return null;
  }

  if (error) {
    return <Alert message="services.fetching.failed" />;
  }

  // get patient's available service integrations
  const noonaData = data.filter((item) => item.name === 'Noona')[0];
  const showNoonaCard = noonaData && noonaData.status !== LUKITTU;
  const taysPolkuData = data.filter((item) => item.name === 'Tays polku')[0];
  const libreviewData = data.filter((item) => item.name === 'Libreview')[0];
  const coxaPolkuData = data.filter((item) => item.name === COXA_POLKU)[0];

  return (
    <div className="service">
      {showNoonaCard && (
        <>
          <FormattedMessage id={`${module_id}.clinic.NOONA`} />
          <NoonaServiceCard data={noonaData} />
        </>
      )}
      {!isEmpty(taysPolkuData) && <TaysPolkuServiceCard disabled={false} />}
      {!isEmpty(libreviewData) && <LibreviewServiceCard />}
      {!isEmpty(coxaPolkuData) && <CoxaPolkuServiceCard />}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { isFetching, data, error } = state[SERVICES].integrations;
  const { data: notificationData } = state[BACKENDNOTIFICATIONS];

  return {
    isFetching,
    data,
    error,
    notificationData,
    taysPolku: state[SERVICES].taysPolku,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    automaticallyDismissNoonaActivationNotification: () =>
      dispatch(automaticallyDismissNoonaActivationNotification()),
    automaticallyDismissTaysPolkuActivationNotification: () =>
      dispatch(automaticallyDismissTaysPolkuActivationNotification()),
    automaticallyDismissCoxaPolkuActivationNotification: () =>
      dispatch(automaticallyDismissCoxaPolkuActivationNotification()),
    automaticallyDismissLibreviewActivationNotification: () =>
      dispatch(automaticallyDismissLibreviewActivationNotification()),
    dismissServiceActivationNotification: (notificationId) =>
      dispatch(doRequestDismissNotifications([notificationId])),
  };
};

const EnhancedServices = injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Services))
);

export default withPageBase(EnhancedServices, {
  title: `${module_id}.title`,
  showPlaceHolder: selectShowServicePagePlaceholder,
});
